import { render, staticRenderFns } from "./boxtitle.vue?vue&type=template&id=43924961&scoped=true"
import script from "./boxtitle.vue?vue&type=script&lang=js"
export * from "./boxtitle.vue?vue&type=script&lang=js"
import style0 from "./boxtitle.vue?vue&type=style&index=0&id=43924961&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43924961",
  null
  
)

export default component.exports